import { useEffect } from "react";
import { SITE_URL } from "@/lib/seo";

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Imperatively manages per-page head tags so canonical/OG/JSON-LD always
// update correctly on client-side (SPA) navigation as well as direct load.
export default function Seo({ title, description, path = "", image, keywords, jsonLd, alternates }) {
  const jsonLdKey = JSON.stringify(jsonLd || null);
  const altKey = JSON.stringify(alternates || null);
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    const img = image || `${SITE_URL}/airport-transfer-24-logo.png`;
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    if (keywords) upsertMeta("name", "keywords", keywords);
    upsertLink("canonical", url);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", "Airport Transfer Zurich");
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", img);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);

    document.head.querySelectorAll("link[data-seo-alt]").forEach((l) => l.remove());
    (Array.isArray(alternates) ? alternates : []).forEach((a) => {
      const l = document.createElement("link");
      l.setAttribute("rel", "alternate");
      l.setAttribute("hreflang", a.hreflang);
      l.setAttribute("href", a.href);
      l.setAttribute("data-seo-alt", "1");
      document.head.appendChild(l);
    });

    document.head.querySelectorAll("script[data-seo-jsonld]").forEach((s) => s.remove());
    const blocks = Array.isArray(jsonLd) ? jsonLd.filter(Boolean) : jsonLd ? [jsonLd] : [];
    blocks.forEach((b) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo-jsonld", "1");
      s.textContent = JSON.stringify(b);
      document.head.appendChild(s);
    });
  }, [title, description, path, image, keywords, jsonLdKey, altKey]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
